import useApplicationData from 'src/hooks/useApplicationData';
import usePlayback from 'src/hooks/usePlayback';
import useResolution from 'src/hooks/useResolution';
import useSubtitle from 'src/hooks/useSubtitle';
import { MEDIA_TYPE, TRANSMISSION_TYPE } from 'src/interfaces/enums';
import MainSettingControl from 'src/themes/cosmos/components/MainSettingControl';
import useSettingsOverlay from '../../hooks/useSettingsOverlay';

const MainSettingControlContainer = () => {
  const { setContainerName } = useSettingsOverlay();
  const { playbackRateLabel } = usePlayback();
  const { subtitleLabel, subtitles } = useSubtitle();
  const { mediaType, transmissionType } = useApplicationData();
  const { resolution, hasNativeHLS } = useResolution();
  const isLive = transmissionType === TRANSMISSION_TYPE.live;
  const isAudio = mediaType === MEDIA_TYPE.audio;

  return (
    <MainSettingControl
      onChange={setContainerName}
      subtitle={{ value: subtitleLabel, visible: Boolean(subtitles?.length) }}
      resolution={{ value: resolution.label, visible: !hasNativeHLS && !isAudio }}
      speed={{ value: playbackRateLabel, visible: !isLive }}
    />
  );
};

export default MainSettingControlContainer;
